module.exports = __webpack_public_path__ + "static/media/p1.704edc79.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/mengduo/p1.svg
// module id = 121
// module chunks = 6